import mapValues from 'lodash/mapValues';
import uniqueId from 'lodash/uniqueId';
import values from 'lodash/values';

interface CreateAreaPoint {
    lngLat: mapboxgl.LngLat;
    area: Area;
    insertBeforePointLocalId?: string;
}

export default function createAreaPoint({
    lngLat,
    insertBeforePointLocalId,
    area,
}: CreateAreaPoint): [string, SimpleArea] | undefined {
    if (!area.isGeometryLoaded || !area.isGeometryEditable) return undefined;

    const insertBeforePoint = insertBeforePointLocalId
        ? area.points[insertBeforePointLocalId]
        : undefined;

    const order = insertBeforePoint
        ? insertBeforePoint.properties.order
        : values(area.points).length;

    const point: AreaPoint = createPoint(lngLat.toArray(), order, area.properties.localId);

    const updatedArea = addPointToArea(area, point);

    return [point.properties.localId, updatedArea];
}

export function createPoint(coordinates: number[], order: number, areaLocalId: string) {
    const localId = uniqueId('point');
    const point: AreaPoint = {
        type: 'Feature',
        geometry: {type: 'Point', coordinates},
        properties: {
            order,
            localId,
            areaLocalId,
            isLocallyCreated: true,
            archived: false,
            title: '',
            type: 'waypoint',
        },
    };
    return point;
}

export function addPointToArea(area: SimpleArea, point: AreaPoint) {
    return {
        ...area,
        points: {
            ...mapValues(area.points, (otherPoint: AreaPoint) => {
                if (otherPoint.properties.order >= point.properties.order) {
                    return {
                        ...otherPoint,
                        properties: {
                            ...otherPoint.properties,
                            order: otherPoint.properties.order + 1,
                        },
                    };
                } else {
                    return otherPoint;
                }
            }),
            [point.properties.localId]: point,
        },
    };
}
